import React from 'react';
import UnitTemplateCategories from '../containers/UnitTemplateCategories.jsx';

const UnitTemplateCategoriesAppClient = (props) => (
  <UnitTemplateCategories {...props} />
);

export default UnitTemplateCategoriesAppClient
